<button mat-icon-button class="close-dialog-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h2 mat-dialog-title>Seleccionar opcion</h2>
<mat-dialog-content class="mat-typography">
  <div flexLayout="row" fxLayoutGap="15px" class="contenedor-iconos">
    <div fxFlex="10" fxLayout="column" class="pointer">
      <div class="contenedor-icon">
        <mat-icon>attach_money</mat-icon>
      </div>
      <span class="titulo-menu"> ANEXO PERSONAL </span>
    </div>
    <div fxFlex="10" fxLayout="column" class="pointer">
      <div
        class="contenedor-icon"
        *ngIf="
          productosPedidosPendientes && productosPedidosPendientes.length <= 0
        "
      >
        <mat-icon (click)="redirectToOrdenesCompra()">book</mat-icon>
      </div>
      <span class="titulo-menu"> COMPRAS </span>
    </div>
    <div fxFlex="10" fxLayout="column" class="pointer">
      <div class="contenedor-icon">
        <mat-icon>compare_arrows</mat-icon>
      </div>
      <span class="titulo-menu"> WORKFLOW </span>
    </div>
    <div fxFlex="10" fxLayout="column" class="pointer">
      <div class="contenedor-icon">
        <mat-icon>account_balance</mat-icon>
      </div>
      <span class="titulo-menu"> BANCOS </span>
    </div>
    <div fxFlex="10" fxLayout="column" class="pointer">
      <div class="contenedor-icon">
        <mat-icon>money_off</mat-icon>
      </div>
      <span class="titulo-menu"> PAGOS </span>
    </div>
    <div fxFlex="10" fxLayout="column" class="pointer">
      <div class="contenedor-icon">
        <mat-icon>payments</mat-icon>
      </div>
      <span class="titulo-menu"> COBROS </span>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close (click)="onNoClick()">
    Cancelar
  </button>
</mat-dialog-actions>
